var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$route.path !== '/')?_c('div',{staticClass:"back"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$router.go(-1)}}},[_vm._v("Вернуться назад")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }